import { Switch, Redirect, Route } from 'react-router';

import { HeaderWithNavigation } from 'src/core/common/components/HeaderWithNavigation/HeaderWithNavigation';
import { ProtectedRoute } from 'src/core/common/components/ProtectedRoute';
import { ErrorBoundary } from 'src/core/common/components/withErrorBoundary';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

import { useOrganisationLinks } from './useOrganisationLinks';
import { useIsMultiEntityHubPage } from '../../app/layout/components/VerticalNavigation/helpers';
import { useHasAccessToMultiEntityConfig } from '../../app/layout/components/VerticalNavigation/useHasAccessToMultiEntityConfig';
import { OrganisationCostCentersPage } from '../components/cost-centers/components/OrganisationCostCentersPage/OrganisationCostCentersPage';

export const MultiEntityHubSettingsPageContainer = () => {
  const { t } = useTranslation('global');
  const company = useCompany();
  const organisationLinks = useOrganisationLinks();
  const isMultiEntityHubPage = useIsMultiEntityHubPage();
  const hasAccessToMultiEntityConfigState = useHasAccessToMultiEntityConfig({
    isEnabled: isMultiEntityHubPage,
  });

  if (hasAccessToMultiEntityConfigState.status !== 'success') {
    return null;
  }

  return (
    <ErrorBoundary
      context={{ scope: 'multi-entity-hub-settings', team: 'control' }}
    >
      <div className="page__container">
        <HeaderWithNavigation links={organisationLinks}>
          {t('navigation.organisation')}
        </HeaderWithNavigation>
        <div className="flex w-full flex-col self-center p-40 pt-24">
          <Switch>
            <Route exact path={routes.ORGANISATION_SETTINGS.path}>
              <Redirect
                to={routeFor(routes.ORGANISATION_COST_CENTERS.path, {
                  company: company.id,
                })}
              />
            </Route>
            <ProtectedRoute
              path={routes.ORGANISATION_COST_CENTERS.path}
              isAccessAllowed={
                hasAccessToMultiEntityConfigState.status === 'success' &&
                hasAccessToMultiEntityConfigState.hasAccess
              }
            >
              <OrganisationCostCentersPage />
            </ProtectedRoute>
          </Switch>
        </div>
      </div>
    </ErrorBoundary>
  );
};
